import { MiniCart, WishlistProducts } from "@repo/components";
import { getCart } from "@repo/server-actions/cart";

const CartIcon = async ({ cartId, locale, session }) => {
  const cart = cartId ? await getCart(locale) : null;

  return (
    <MiniCart
      locale={locale}
      session={session}
      cartTotalsInfo={cart}
      WishlistProducts={
        <WishlistProducts locale={locale} session={session} className="ml-0" />
      }
    />
  );
};

export default CartIcon;
